export default [
    {
        path: "driver",
        name: "driver-attendance",
        redirect: { name: "driver-attendance-month" },
        component: () => import("@/views/driver/views/attendance/Attendance.vue"),
        meta: {
            section: 16,
            breadcrumb: [
                {
                    text: "Attendance",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "Month",
                    name: "driver-attendance-month",
                },
                {
                    title: "Viatics",
                    name: "driver-attendance-viatics",
                },
            ],
        },

        children: [
            {
                path: "month",
                name: "driver-attendance-month",
                component: () =>
                    import("@/views/driver/views/attendance/components/MonthComponent.vue"),
                meta: {
                    section: 16,
                    pageTitle: "Attendance",
                    breadcrumb: [
                        {
                            text: "Month",
                            active: true
                        },
                    ],
                    tab: 1,
                },
            },
            {
                path: "viatics",
                name: "driver-attendance-viatics",
                component: () => import("@/views/driver/views/attendance/components/ViaticComponent.vue"),
                meta: {
                    section: 16,
                    pageTitle: "Attendance",
                    breadcrumb: [
                        {
                            text: "Viatics",
                            active: true,
                        },
                    ],
                    tab: 2,
                },
            },
        ],
    },
];
